module.exports = __webpack_public_path__ + "static/media/frc-halloween-top-asset.deb237fb.png";